module.exports = __webpack_public_path__ + "static/img/appcode.c851cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appcode.png
// module id = R/01
// module chunks = 2